export default __webpack_public_path__ + "static/media/businessman.edeb5670.png";